import type { Enums } from '@gymcoach/shared';

export type Role = Enums<'user_role'>;
export type StaffRole = Exclude<Role, 'client'>;

/** Owner and admin: everything in the gym (owner-only actions aside). */
export const ADMIN_ROLES: readonly StaffRole[] = ['owner', 'admin'];
/** Everyone who uses the CRM. Trainers see only their own clients (RLS). */
export const STAFF_ROLES: readonly StaffRole[] = ['owner', 'admin', 'trainer'];
export const OWNER_ROLES: readonly StaffRole[] = ['owner'];

export const ROLE_LABELS: Record<Role, string> = {
  owner: 'Owner',
  admin: 'Admin',
  trainer: 'Trainer',
  client: 'Member',
};

export function hasRole(role: Role | null | undefined, allowed: readonly Role[]): boolean {
  return role !== null && role !== undefined && allowed.includes(role);
}
